import { LogTypesEnum } from '../enums';

export interface ICreateLogInput {
    tripId: string;
    message: string;
    datetime?: string;
    type?: LogTypesEnum;
    seenBy?: string[];
}
